__turbopack_context__.v({
  "avatar_card": "styles-module__g5NKCG__avatar_card",
});
